"use client";

import { GlobalConsumer } from "@/data/store";
import { type Product } from "@repo/schemas";
import { ProductDetails } from "../blocks/ProductDetails";
import { RelatedProducts } from "../blocks/RelatedProducts";

export function ProductDetailsContainer({
  product,
  relatedProducts,
}: {
  product: Product;
  relatedProducts: Product[];
}) {
  return (
    <div className="m-auto flex max-w-[1800px] flex-col gap-8 p-2 lg:p-8">
      <GlobalConsumer mutations={["addToCart"]}>
        {({ addToCart }) => (
          <ProductDetails product={product} onAddToCart={() => addToCart(product)} />
        )}
      </GlobalConsumer>
      <RelatedProducts products={relatedProducts} />
    </div>
  );
}
